'use client';

import UserService from "@/services/User.service";
import { useEffect, useState } from "react";

export function useIsUserAuthenticated() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    UserService.validateSession().then((isUserSessionValid) => {
      setIsAuthenticated(isUserSessionValid);
    })
  }, []);
  return isAuthenticated;
}
